SearchComponentJS.additionalFiltering = function (filterJSONObject) {
    if (!$(".additional-default-size").length) {
        return;
    }

    if (!filterJSONObject || filterJSONObject.initiatorName !== "vehicleTypes[0]") {
        return;
    }

    var vehicleType = filterJSONObject.initiatorValue;

    if (window.localStorage.getItem('enablePreselectedCarAbTesting') && window.localStorage.getItem('tyreVehicleData')
        && vehicleType == "PKW") {
        var vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));
        if (vehicleData.width && vehicleData.tyreProfile && vehicleData.size) {
            filterJSONObject.width = vehicleData.width;
            filterJSONObject.profile = vehicleData.tyreProfile;
            filterJSONObject.size = vehicleData.size;
            return;
        }
    }

    var $sizeInput = $(".additional-default-size[name='additional-size-" + vehicleType + "']");
    if ($sizeInput.length) {
        if ($sizeInput.data("width") && $sizeInput.data("profile") && $sizeInput.data("size")) {
            filterJSONObject.width = $sizeInput.data("width");
            filterJSONObject.profile = $sizeInput.data("profile");
            filterJSONObject.size = $sizeInput.data("size");
        }
    }
};

